import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { statusActions } from "../../../store/status-slice";
import styles from "./PharmacyImagesAndStatus.module.scss";
import PharmaciesImagesModal from "../PharmacieImagesModal/PharmaciesImagesModal";
import axios, { baseUrl } from "../../../axios/axios";
import Button from "../../UI/Buttons/Button/Button";
import { fetchMarketPlaceDetails } from "../StatusComponent";
import { fetchMarketplaceInfo } from "../../../store/auth-actions";

const PharmacyImagesAndStatus = ({
  marketplaceInfoDetailed,
  marketplaceInfo,
  statusToggle,
  logout,
  setMarketplaceInfoDetailed,
}: any) => {
  const dispatch = useDispatch();
  const showStatusScreen = () => {
    dispatch(statusActions.toggleStatusScreen(false));
  };
  const [activeButtonTitle, setActiveButtonTitle] = useState("Status: aktivna");

  useEffect(() => {
    if (marketplaceInfo && marketplaceInfo?.takesOrders === 1) {
      setActiveButtonTitle("Status: aktivna");
    } else {
      setActiveButtonTitle("Status: neaktivna");
    }
  }, [marketplaceInfo]);
  useEffect(() => {
    if (marketplaceInfo && marketplaceInfo?.takesOrders === 1) {
      setActiveButtonTitle("Status: aktivna");
    } else {
      setActiveButtonTitle("Status: neaktivna");
    }
  }, [marketplaceInfo]);

  console.log("refresh", marketplaceInfoDetailed);

  const imageSrc =
    marketplaceInfoDetailed?.pictures?.length > 0
      ? process.env.REACT_APP_CDN_PATH + `marketplace_images/${marketplaceInfoDetailed?.pictures[0]}`
      : "";

  return (
    <div className={styles.pharmacyImagesAndStatus}>
      <div className={styles.coverImage}>
        <PharmaciesImagesModal
          submitImageChange={(imageList: any, initImageList: any) =>
            updateImages(marketplaceInfoDetailed, imageList, initImageList).then(() => {
              const branchMarketplaceId = localStorage.getItem("branchMarketplaceId");
              const marketplaceId = localStorage.getItem("marketplaceId");
              fetchMarketPlaceDetails(branchMarketplaceId, marketplaceId).then((res) =>
                setMarketplaceInfoDetailed(res.data)
              );
              dispatch<any>(fetchMarketplaceInfo(parseInt(localStorage.getItem("id")!)));
            })
          }
          currentImages={marketplaceInfoDetailed?.pictures}
        />
        <img className={styles.image} alt="img" src={imageSrc} width={160} height={160} />
      </div>
      <div className={styles.pharmacyName}>{marketplaceInfoDetailed && marketplaceInfoDetailed.name}</div>
      <div className={styles.pharmacyStatus}>
        <div className={styles.buttons}>
          <Button
            className={styles.actionButton}
            buttonType={marketplaceInfo.takesOrders === 1 ? "blue" : "red"}
            onClick={statusToggle}>
            {activeButtonTitle}
          </Button>
          <Button className={styles.actionButton} onClick={() => showStatusScreen()} buttonType="blue">
            Pregled Porudzbina
          </Button>
        </div>
      </div>
      <Button className={styles.logoutButton} onClick={logout}>
        Odjavi se
      </Button>
    </div>
  );
};

export default PharmacyImagesAndStatus;

const updateImages = (data: any, imageList: any, initImageList: any) => {
  let initItemNames = initImageList || [];

  const imagesNames = imageList.map((img: any) => {
    return img?.file?.name;
  });
  initItemNames = [...initItemNames, ...imagesNames];
  const formData = new FormData();
  const payload = {
    ...data,
  };
  payload.pictures = initItemNames?.map((pic: any) => ({
    imageLink: pic,
    priority: 1,
    isSmall: 0,
  }));

  formData.append("marketplaceRequestString", JSON.stringify(payload));
  imageList.forEach((i: any) => formData.append("images", i?.file));
  return axios.put(baseUrl + "/marketplace", formData);
};
